export default __webpack_public_path__ + "static/media/g1.1224845d.jpg";